import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';

import {
    TransformResponse
} from './transform';

import {
    addActionMeditech as addPatientGlobalSearchMeditech,
    setSpin,
} from 'one-state-patient-global-search';
import { format } from 'one-util-date';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {
    setAction as lookupErrorSet,
} from "one-state-subjecterror/src/action";

export const enum Types {
    SEARCH_MEDITECH = 'one-state-patient-global-search/search-meditech',
    ADD_MEDITECH = 'one-state-patient-global-search/add-meditech',
    PushDatatoSubject = 'one-state-subject/set',
}

import { InvokeFinesseProxy } from '../../../subject/src/index';

const pushToSetPatientGlobalSearch = (payload: any) => addPatientGlobalSearchMeditech(payload);

/**
 * This Function fetches data from getgetpatientepicglobal api
 * @param context contains settings.json etc...
 */
export const fetchPatientsGlobalSearchMeditech = (context: any) => (
    (action$: ActionsObservable<any>) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server,
            log,
            alertnotification,
            settings:
            {
                servers, compatible, meditechendpoints: { getpatientmeditech }
            }
        } = context;
        const { finesse_proxy_service } = compatible;
        const { locations = [] } = servers;
        return action$.pipe(
            ofType(Types.SEARCH_MEDITECH),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient global search request
                 */

                const dataresponse: any = action.payload;
                log.debug("one-meditech", "patient-global-search request", dataresponse);
                const getCallerDetails = (payload: any) => {
                    let headers = new Headers();
                    headers.append("Accept", "application/json");
                    headers.append("Content-Type", "text/plain");
                    let getParams = "";
                    var parts = payload.birthdate.split('-');

                    if (payload.phone) {
                        getParams += "&PhoneNumber=" + payload.phone;
                    }

                    if (payload.name) {
                        getParams += "&Name=" + payload.name;
                    }

                    if (payload.birthdate) {
                        getParams += "&DateOfBirth=" + parts[2] + '-' + parts[0] + '-' + parts[1];
                    }

                    if (payload.id) {
                        getParams += "&PatientID=" + payload.id;
                    }

                    // Remove the leading "&" if there are any parameters
                    if (getParams.length > 0) {
                        getParams = "?" + getParams.substring(1);
                    }
                    let response;
                    if (finesse_proxy_service) {
                        //response = InvokeFinesseProxy(getpatientepic, data, locations, log, 'POST', alertnotification);

                    } else {
                        response = server.get({
                            path: getpatientmeditech + getParams,
                            headers: headers
                        }).then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                log.error("one-epic", "patient-global-search-athena Error", responseresult);
                                let pgserror: ErrorObject = {
                                    source: "Patient Global Search",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return pgserror;
                            })
                        log.debug("one-epics", "patient-global-search-athena response", response);
                    }
                    return from(response);
                }
                return getCallerDetails(dataresponse).pipe(
                    map(response => TransformResponse(response, context))
                ).pipe(
                    flatMap(response => {
                        const payloadPhone = dataresponse.phone ? dataresponse.phone.replace(/\D/g, '') : null;
                        let payloadparam = ""
                        if (dataresponse?.id) {
                            payloadparam = dataresponse.id
                        }
                        else if (dataresponse?.name) {
                            payloadparam = dataresponse.name
                        }
                        else if (dataresponse?.birthdat) {
                            payloadparam = dataresponse.birthdate
                        }
                        else if (dataresponse?.phone) {
                            payloadparam = dataresponse.phone
                        }
                        const responseData = response.subjectdata.map((subject: any) => {
                            if (payloadPhone) {
                                subject.phoneNumbers = subject.phoneNumbers.filter((item: any) => item.Number.replace(/\D/g, '') === payloadPhone)
                            }
                            subject.phone = subject.phoneNumbers?.length > 0 ? subject.phoneNumbers[0] : {}
                            return subject
                        })
                        const actions: any = [
                            pushToSetPatientGlobalSearch(responseData)
                        ];
                        // check for error messages.
                        if (response.success===false) {
                            actions.push(addAction(response.error));
                            //To store the error object in the reducer.
                            actions.push(lookupErrorSet(response.error));
                        }
                        return actions;
                    })
                )
            })
        )
    }

);

/**
 * This Fuction will stop spinner for 
 * patient global search epic redux action
 * @param context contains the settings,logger etc..
 */
export const resetSpinForPateintGlobalSearchMeditech = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget,patient-global-search-meditech",
            "setSpin-patient-global-search-meditech", {
        });
        return action$.pipe(
            ofType(Types.ADD_MEDITECH),
            map(action => setSpin(false))
        )
    }
);
